import React from 'react'

import WelcomePage from './WelcomePage'

const WelcomeAdvisor = props => {
  const { superHeadline, heading, backgroundImage } = props.content
  return (
    <div>
      <WelcomePage
        superHeadline={superHeadline}
        heading={heading}
        backgroundImage={backgroundImage}
      />
    </div>
  )
}

export default WelcomeAdvisor
